/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description React Hook usePostEligibilityRequest
 */
import _ from 'lodash';
import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import api from 'client/index';
import AppEvents from '@veritable/common/utils/appEvents';
import { invalidateMetadata } from 'app-constants/queryKeys';
import { useClaimStatusRequestsStoreActions, defaultPagination } from 'store/claimsRequests';
import { getClaimResponsePath, getClaimsRequestPath } from 'utils/router';

type IParams = {
	model: ClaimStatusRequestForm.ISubmitModel;
};

/**
 * Mutate for post eligibility request
 */

const redirectToClaimDetailScreen = (data: ClaimStatusResponse.IModel[], setPageNumber: (pageNumber: number) => void): void => {
	if (_.size(data) === 1) {
		AppEvents.publishRedirect({ url: getClaimResponsePath(_.first(data)?.claimId) });
	}
	// redirect to filtered response screen for multiple claim response
	else {
		// set page number to 1 if there are multiple response
		setPageNumber(defaultPagination.pageNumber);
		const idsList = _.compact(_.map(data, ({ claimId }) => claimId));
		AppEvents.publishRedirect({ url: getClaimsRequestPath({ idsList, returnDefault: true }) });
	}
};
const usePostClaimStatusRequest = (): UseMutationResult<ClaimStatusResponse.IModel[], IAxiosError, IParams, unknown> => {
	const queryClient = useQueryClient();
	const { setPageNumber } = useClaimStatusRequestsStoreActions();
	return useMutation({
		mutationFn: async ({ model }) => {
			const { data } = await api.EzapiApi.postClaimStatusRequests({ claimStatusRequest: [model] });
			return data as ClaimStatusResponse.IModel[];
		},
		onSuccess: (data) => {
			AppEvents.publishApiSuccess();
			invalidateMetadata(queryClient);
			// redirect to output screen
			redirectToClaimDetailScreen(data, setPageNumber);
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export { redirectToClaimDetailScreen };
export default usePostClaimStatusRequest;
